<template>
  <div
    class="modal fade"
    id="newScoreModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="newScoreModalLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
            >&times;</span>
          </button>
          <h4
            class="modal-title"
            id="newScoreModalLabel"
          >
            {{ $t('label.newScore') }}
          </h4>
        </div>
        <div
          class="modal-body"
          v-if="selectedCriteria"
        >
          <template v-if="selectedCriteria.value_type && selectedCriteria.value_type === 'range'">
            <div
              :class="'form-group ' + (validations !== null && validations.hasOwnProperty('from') ? 'has-error' : '')"
            >
              <label class="required">{{ $t('label.from') }}</label>
              <input
                type="text"
                :value="score.from"
                @input="updateFormDataFrom"
                class="form-control"
                :placeholder="$t('label.from')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('from')"
              >
                {{ validations['from'][0] }}
              </span>
            </div>
            <div class="form-group">
              <label class="required">{{ $t('label.to') }}</label>
              <input
                type="text"
                :value="score.to"
                @input="updateFormDataTo"
                class="form-control"
                :placeholder="$t('label.to')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('to')"
              >
                {{ validations['to'][0] }}
              </span>
            </div>
          </template>
          <template v-else-if="selectedCriteria.value_type === 'reference'">
            <div class="form-group">
              <label class="required">{{ $t('label.value') }}</label>
              <select
                class="form-control"
                @change="updateFormDataValue"
                :value="score.value"
              >
                <option
                  v-for="(item, key) in options"
                  :key="key"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('value')"
              >
                {{ validations['value'][0] }}
              </span>
            </div>
          </template>
          <template v-else>
            <div class="form-group">
              <label class="required">{{ $t('label.value') }}</label>
              <input
                type="text"
                :value="score.value"
                @input="updateFormDataValue"
                class="form-control"
                :placeholder="$t('label.value')"
              >
            </div>
          </template>
          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('score') ? 'has-error' : '')"
          >
            <label class="required">{{ $t('label.score') }}</label>
            <input
              type="number"
              :value="score.score"
              @input="updateFormDataScore"
              class="form-control"
              :placeholder="$t('label.score')"
            >
            <span
              class="label-error"
              v-if="validations !== null && validations.hasOwnProperty('score')"
            >
              {{ validations['score'][0] }}
            </span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            ref="closeModal"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button
            type="button"
            @click="store"
            :disabled="isSubmitting"
            class="btn btn-primary"
          >
            <i :class="`fa fa-${isSubmitting ? 'spinner fa-pulse fa-fw' : 'check-circle'}}`" />
            <template v-if="isSubmitting">
              {{ $t('button.processing') }}
            </template>
            <template v-else>
              {{ $t('button.save') }}
            </template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ScoreModal',
  data () {
    return {
      isSubmitting: false,
      options: [],
      validations: null
    }
  },
  watch: {
    'selectedCriteria' () {
      this.$store.commit('profileScoring/updateFormDataCriteria', this.selectedCriteria)
      const { value_type } = this.selectedCriteria
      if (value_type === 'reference') {
        this.getOptions()
      } else {
        this.options = []
      }
    }
  },
  computed: {
    ...mapState({
      selectedCriteria: state => state.profileScoring.selectedCriteria,
      score: state => state.profileScoring.score
    })
  },
  methods: {
    updateFormDataScore (e) {
      this.$store.commit('profileScoring/updateFormDataScore', e.target.value)
    },
    updateFormDataValue (e) {
      this.$store.commit('profileScoring/updateFormDataValue', e.target.value)
    },
    updateFormDataFrom (e) {
      this.$store.commit('profileScoring/updateFormDataFrom', e.target.value)
    },
    updateFormDataTo (e) {
      this.$store.commit('profileScoring/updateFormDataTo', e.target.value)
    },
    resetState () {
      this.$store.commit('profileScoring/resetScoreState')
    },
    store () {
      this.isSubmitting = true
      this.score.criteria_id = this.selectedCriteria.id
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/profile-scoring/store-criteria-scores', this.score)
        .then((response) => {
          if (response.data.code === 1) {
            this.$emit('refreshTable')
            this.$refs.closeModal.click()
            this.$toastr(
              'success',
              this.$t('string.theRequestHaveBeenProceeded'),
              this.$t('string.success')
            )
          } else {
            this.validations = response.data.message
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    getOptions () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/profile-scoring/get-options', {
        criteria_id: this.selectedCriteria.id
      }).then((response) => {
        this.options = response.data
      })
    }
  },
  mounted () {
    this.$store.commit('profileScoring/updateFormDataCriteria', this.selectedCriteria)
  }
}
</script>

<style scoped>

</style>
